<template>
  <div class="lms-wrapper-two">
    <student-nav :obj.sync="statObj"></student-nav>

    <div class="lms-content">
      <student-header class="filled" @toggle-navbar="toggleNavbar($event)" />
      
      <div class="lms-content-body container" style="bottom: 0; height: calc(100vh - 80px)">
        <ul class="nav nav-line nav-line-profile mg-b-10">
          <li class="nav-item">
            <router-link
              to="/lms/eventList/0"
              aria-current="page"
              :class="
                `nav-link d-flex align-items-center ${
                  $route.params.status == 0 ? 'active' : ''
                }`
              "
            >
              Нээлттэй
              <span class="badge">{{ counts.active }}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/lms/eventList/1"
              aria-current="page"
              :class="
                `nav-link d-flex align-items-center ${
                  $route.params.status == 1 ? 'active' : ''
                }`
              "
            >
              Оролцсон
              <span class="badge">{{ counts.joined }}</span>
            </router-link>
          </li>
        </ul>
        <div class="row">
          <div class="col-lg-8 col-xl-9">
            <vue-custom-scrollbar
              :style="`height: ${scrollHeight.content}px; position: relative; `"
            >
              <div class="row row-sm mg-b-25">
                <div
                  v-for="(event, i) in list.filter(x =>
                    $route.params.status == 1
                      ? x.isJoined == true
                      : x.date.future == true &&
                        (x.request.flag == flag1 || x.request.flag == 1)
                  )"
                  :key="'event' + i"
                  class="col-md-6 mg-t-20 mg-md-t-0"
                >
                  <div class="card card-event">
                    <img
                      :src="event.cover + '?w=600&h=270'"
                      class="card-img-top"
                      alt
                    />
                    <div class="card-body tx-13">
                      <h5>
                        <a>{{ event.task }}</a>
                      </h5>
                      <p class="mg-b-0">
                        {{ event.date.start | moment("YYYY.MM.DD HH:mm") }} -
                        {{ event.date.end | moment("YYYY.MM.DD HH:mm") }},
                        {{ event.location }}
                      </p>
                      <span class="tx-12 tx-color-03">{{
                        event.locType != null ? event.locType.name : ""
                      }}</span>
                    </div>
                    <div class="card-footer tx-13">
                      <span class="tx-color-03"
                        >{{ event.member.count }} оролцогч</span
                      >
                      <button
                        class="btn btn-xs btn-secondary"
                        @click="showDetail(event.id)"
                      >
                        Дэлгэрэнгүй
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </vue-custom-scrollbar>
          </div>
          <div class="col-sm-7 col-md-5 col-lg-4 col-xl-3 mg-t-40 mg-lg-t-0">
            <vue-custom-scrollbar
              :style="`height: ${scrollHeight.right}px; position: relative;`"
            >
              <!-- <div class="d-flex align-items-center justify-content-between mg-b-20">
                <h6 class="tx-uppercase tx-semibold mg-b-0">Удахгүй болох</h6>
              </div>
              <ul class="list-unstyled media-list mg-b-15">
                <li class="media align-items-center">
                  <div
                    class="wd-40 ht-40 bg-dark tx-white d-flex align-items-center justify-content-center rounded"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-calendar"
                    >
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                  </div>
                  <div class="media-body pd-l-15">
                    <h6 class="mg-b-2">
                      <a href class="link-01">Үйл явдал</a>
                    </h6>
                    <span class="tx-13 tx-color-03">Today, April 21, 5:00pm</span>
                  </div>
                </li>
                <li class="media align-items-center mg-t-15">
                  <div
                    class="wd-40 ht-40 bg-indigo tx-white d-flex align-items-center justify-content-center rounded"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-calendar"
                    >
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                  </div>
                  <div class="media-body pd-l-15">
                    <h6 class="mg-b-2">
                      <a class="link-01">Үйл явдал</a>
                    </h6>
                    <span class="tx-13 tx-color-03">Tomorrow, April 22, 3:00pm</span>
                  </div>
                </li>
              </ul> -->
              <template v-if="types.length > 0">
                <h6 class="tx-uppercase tx-semibold mg-b-15">Ангилал</h6>
                <nav class="nav nav-classic tx-13">
                  <a
                    v-for="(type, i) in types"
                    class="nav-link"
                    :key="'tp_' + i"
                  >
                    <!-- {{type}} -->
                    <span>{{ type.s1 }}</span>
                    <!-- <span class="badge">20</span> -->
                  </a>
                </nav>
              </template>
            </vue-custom-scrollbar>
          </div>
        </div>
      </div>
    </div>


    
    <b-modal
      v-model="modal.show"
      hide-footer
      :title="modal.data.task"
      centered
      body-class="pd-0"
      size="lg"
      scrollable
    >
      <!-- <div class="modal-header">
        <h6 class="modal-title" id="exampleModalLabel3">Modal Title</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>-->
      <div class="modal-body">
        <div class="card card-profile card-event">
          <img
            :src="modal.data.defaultAttachmentUrl"
            alt
            class="card-img-top"
            style="height: 350px"
          />
          <div class="card-body tx-13 pd-y-10-f">
            <div class="avatar wd-140 ht-140 mt-n80px pos-relative">
              <img
                :src="`${groupLogo}?w=144&h=144&mode=crop`"
                alt
                class="rounded-circle img-thumbnail border-0 pd-0-f"
              />
            </div>
            <div class="ht-50 align-items-start mg-l-150 pd-l-10">
              <div class="d-flex align-items-center wd-100p">
                <div>
                  <h6>
                    <a>{{ modal.data.task }}</a>
                  </h6>
                  <p class="mg-b-0">
                    {{ modal.data.dueStartDate | moment("YYYY.MM.DD") }} -
                    {{ modal.data.dueDate | moment("YYYY.MM.DD") }}
                  </p>
                </div>
                <div class="mg-l-auto">
                  <!-- {{modal.data.defaultAttachmentUrl}}
                    {{modal.data.createdUser}}
                    {{modal.data.im == null}} -->
                  <button
                    v-if="modal.data.im == null"
                    @click="showPayment(modal.data.id)"
                    class="btn btn-xs btn-uppercase btn-primary"
                  >
                    Оролцох
                  </button>
                  <template v-else>
                    <span class="badge badge-success">Та оролцож байна.</span>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!---->
        </div>
        <div class="divider-text">Дэлгэрэнгүй</div>

        <div v-html="modal.data.taskDesc"></div>
        <!-- <div class="row">
          
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            
          </div>
        </div> -->
      </div>
    </b-modal>
    <b-modal
      :transition-names="[]"
      v-model="mandatVisible"
      title="Тасалбар"
      footer-hide
      class="learning-home"
      width="600px"
    >
      <div style="min-height: 300px" ref="printArea" id="prntee">
        <div v-html="eventDetail.f1"></div>
        <table>
          <tr>
            <td>
              • Цахим тасалбарын QRCODE бүхий хэсгийг нугалж үрчийлгэсэн
              тохиолдолд бүртгэх боломжгүй болохыг анхаарна уу
            </td>
            <td rowspan="2" style="width: 100px">
              <qrcode-vue
                id="qr_canvas"
                :value="qrOption.value"
                :size="qrOption.size"
                level="H"
              ></qrcode-vue>
              <img id="dsfgsdgsdfsdf" :src="bse64" />
            </td>
          </tr>
          <tr>
            <td>
              • Энэхүү тасалбарыг хэвлэн үйл явдалд оролцох үедээ бүртгэлийн
              ажилтанд уншуулж бүртгүүлнэ үү
            </td>
          </tr>
        </table>

        <div style="text-align: right; margin-top: 20px">
          Powered by:
          <img v-if="!($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249)"
            src="https://res.gosmart.mn/media/favicon/fav.png"
            style="margin-right: 5px; margin-bottom: -4px"
          /><b>Динамик платформ</b>
        </div>
      </div>
      <button class="notprint" @click="printElem">Хэвлэх</button>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";
import {
  getInheritedTask,
  postInheritedTask
  
} from "@/api/task";

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

export default {
  components: {
    vueCustomScrollbar,
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0
      },
      counts: {
        joined: 0,
        active: 0
      },
      list: [],
      rawList: [],
      modal: {
        id: 0,
        show: false,
        data: {}
      },
      types: [],
      flag1: -1,
      groupLogo: "",
      mandatVisible: false,
      qrOption: {
        value: "",
        size: 150
      },
      bse64: "",
      eventDetail: {}
    };
  },
  mounted() {
    // this.toggleBodyClass("addClass", "app-lms");
    // require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();
    //alert(this.$store.state.user.userInfo.locType4Code)
    if (this.$store.state.user.userInfo.locType4Code == "member") {
      this.flag1 = 2;
    } else if (
      this.$store.state.user.userInfo.locType4Code == "register" ||
      this.$store.state.user.userInfo.locType4Code == "learning"
    ) {
      this.flag1 = 3;
    }

    let _companyLogo = this.$store.state.app.groupSettings.filter(
      x => x.key == "companyLogo"
    );
    if (_companyLogo.length > 0 && _companyLogo[0].value != undefined) {
      this.groupLogo = _companyLogo[0].value;
    }

    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    init() {
      //getFutureEventList()
      request({
        api: { method: "get", url: "type/getdata" },
        params: {
          key: "lmsEventType",
          getParentType: false
        },
        store: this.$store
      }).then(res => {
        //this.handleLoading({ isLoading: false });
        if (res != false) {
          this.types = res.data.types;
        }
      });

      request({
        api: { method: "get", url: "learn/getFutureEventList" },
        store: this.$store
      }).then(res => {
        this.list = _.orderBy(res.data.tasks, ["id"], ["desc"]);
        this.counts.active = res.data.tasks.filter(
          x =>
            (x.request.flag == this.flag1 || x.request.flag1 == 1) &&
            x.date.future
          //this.isActiveNow(x.request.start, x.request.end)
        ).length;
        this.counts.joined = res.data.tasks.filter(
          x => x.isJoined
          //&& !this.isActiveNow(x.date.start, x.date.end)
        ).length;
      });
    },
    showPayment(eventId) {
      //console.log(eventId);
      //taskInheritedDetail({ id: eventId }).then((res) => {
      //this.eventDetail = res.data.task;

      //console.log(this.$store.state.user.userInfo);

      // getInheritedTask({
      //   id: this.$store.state.user.userInfo.profileId,
      // }).then((resProfile) => {
      //if (resProfile != false) {
      //let profileModel = resProfile.data.task;

      let invoiceBoxId = 0;
      if (this.eventDetail.b.filter(x => x.ot == 343).length > 0) {
        invoiceBoxId = this.eventDetail.b.filter(x => x.ot == 343)[0].id;
      }

      let _projid = 0;
      if (
        this.$store.state.app.groupDefaultProjects.filter(
          x => x.objectTypeId == 343
        ).length > 0
      ) {
        _projid = this.$store.state.app.groupDefaultProjects.filter(
          x => x.objectTypeId == 343
        )[0].id;
      }

      getInheritedTask({
        params: {
          id: 0,
          projectId: _projid,
          parentId: 0,
          boxId: invoiceBoxId,
          objectTypeId: 343,
          userId: this.$store.state.user.userInfo.user_id
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          let submitModel = res.data.task;

          submitModel.task = this.eventDetail.task;
          submitModel.taskDesc =
            this.eventDetail.task +
            " төлбөр. Овог: " +
            this.$store.state.user.userInfo.ovog +
            " Нэр: " +
            this.$store.state.user.userInfo.ner +
            " Регистр: " +
            this.$store.state.user.userInfo.register;
          submitModel.thirdOrganizationTaskId = this.eventDetail.id;
          submitModel.parentId = 0;

          postInheritedTask({
            data: { model: submitModel },
            store: this.$store
          }).then(res => {
            if (res.result == 1) {
              this.task = {};
              request({
                api: {
                  method: "POST",
                  url: "Payment/PostProductAndWorkservice"
                },
                data: {
                  invoiceId: res.taskId,
                  workIds: [this.eventDetail.id]
                },
                store: this.$store
              }).then(resWork => {
                if (resWork != false) {
                  //console.log(resWork);
                  if (resWork.data.result == 1) {
                    // this.payInvoiceId = res.taskId;
                    // this.gopymntKey++;
                    // this.paymentVisible = true;
                    this.$router.push(`/lms/paymentDetail/${res.taskId}`);
                  } else if (resWork.data.result == 0) {
                    this.showDetail(eventId);
                    // invoice 0 duntei uchir tologdson

                    // this.init();
                    // this.$emit("on-invoice-created");
                  } else if (resWork.data.result == 2) {
                    //tolbortei ch gsn shuud elsuul gesen songolt orj irsen uyed tologdson
                    if (this.list.filter(x => x.id == eventId).length > 0) {
                      // this.list.filter(
                      //   (x) => x.id == eventId
                      // )[0].isJoined = true;
                      // this.list.filter((x) => x.id == eventId)[0].member
                      //   .count++;
                      // this.$emit("on-invoice-created");
                      // this.sendRequest(
                      //   this.list.filter((x) => x.id == eventId)[0]
                      // );
                      this.showDetail(eventId);
                    }
                  } else {
                    Notification.error({
                      message:
                        "Байгууллага хариуцсан мэргэжилтэнд хандана уу. ",
                      duration: 5000,
                      type: "error",
                      position: "top-right",
                      offset: 50
                    });
                  }
                }
              });
            }
          });
        } else {
          Notification.error({
            message:
              "Та оролцох хүсэлт илгээсэн байна. Нэхэмжлэх хэсгээс төлөгдөөгүй нэхэмжлэхийг төлнө үү. ",
            duration: 5000,
            type: "error",
            position: "top-right",
            offset: 50
          });
        }
      });
      //}
      //});
      //});
    },
    printElem() {
      this.$htmlToPaper("prntee", () => {});
    },
    printQ() {
      var _content = this.$refs.printArea.innerHTML;
      var mywindow = window.open("", "Print", "height=600,width=800");

      mywindow.document.write("<html><head><title>Print</title>");

      mywindow.document.write(
        "</head><body> <style>.table-god thead tr th, .table-god tbody tr td {    vertical-align: middle;    border: 1px solid rgba(0, 0, 0, 0.05) !important;    font-weight: normal;    font-size: 10px;      padding: 4px 6px !important;   }        </style>"
      );
      mywindow.document.write(_content);
      mywindow.document.write("</body></html>");

      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      mywindow.close();
      //window.print();
    },
    showDetail(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");

      request({
        api: { method: "get", url: "task/taskInheritedDetail" },
        params: { id: id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.modal.id = id;
          this.modal.data = res.data.task;
          this.eventDetail = res.data.task;
          this.modal.show = true;
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    }
  }
};
</script>
